import React from "react";
import { IoMdAddCircle } from "react-icons/io";
import { Col, Input, Row } from "reactstrap";
import { MdDelete } from "react-icons/md";

const DealFactorItems = ({
  item,
  newItems,
  checked,
  state,
  selectedPackages,
  handleInputChange,
  handlePackageSelection,
  handleAddItemToPackages,
  handleDealFactorItemDeletion,
}) => {
  return (
    <div className="deal-factor-items-container">
      {item.packages.map((packageItem, packageIndex) => (
        <div key={packageIndex} className="deal-factor-item">
          <div className="deal-factor-item-content">
            <Input
              type="checkbox"
              className="deal-factor-item-checkbox"
              onChange={() =>
                handlePackageSelection(item.Id, packageIndex, {
                  ...packageItem,
                  checked: !(`${item.Id}-${packageIndex}` in selectedPackages),
                })
              }
              checked={`${item.Id}-${packageIndex}` in selectedPackages}
            />
            <div className="deal-factor-item-text">
              <span className="deal-factor-item-title">
                {packageItem.title}
              </span>
              <p className="deal-factor-item-description">
                {packageItem.description}
              </p>
            </div>
          </div>
          <div className="deal-factor-item-content">
            <strong className="deal-factor-item-price">
              ${packageItem.price}/{packageItem.units}
            </strong>
            <span
              className="deal-factor-item-delete"
              onClick={() =>
                handleDealFactorItemDeletion(item.Id, packageIndex)
              }
            >
              <MdDelete size={18} />
            </span>
          </div>
        </div>
      ))}
      <div className="deal-factor-item-inputs">
        <div className="deal-factor-item-input-row">
          <div className="deal-factor-item-input-col title">
            <Input
              type="text"
              className="deal-factor-item-input"
              placeholder="Item Title"
              value={newItems[item.Id]?.title || ""}
              onChange={(e) =>
                handleInputChange(item.Id, "title", e.target.value)
              }
            />
          </div>
          <div className="deal-factor-item-input-col price">
            <Input
              type="number"
              className="deal-factor-item-input"
              value={newItems[item.Id]?.price || ""}
              onChange={(e) =>
                handleInputChange(item.Id, "price", e.target.value)
              }
              placeholder="Price"
            />
          </div>
          <div className="deal-factor-item-input-col units">
            <Input
              type="select"
              className="deal-factor-item-input"
              value={newItems[item.Id]?.units || ""}
              onChange={(e) =>
                handleInputChange(item.Id, "units", e.target.value)
              }
              placeholder="units"
            >
              <option value="">select...</option>
              <option value="piece">piece</option>
              <option value="box">box</option>
              <option value="pack">pack</option>
              <option value="case">case</option>
              <option value="set">set</option>
              <option value="pair">pair</option>
              <option value="unit">unit</option>
              <option value="hour">hour</option>
              <option value="minute">minute</option>
              <option value="day">day</option>
              <option value="month">month</option>
              <option value="liter">liter</option>
              <option value="pound">pound (lb)</option>
              <option value="ounce">ounce (oz)</option>
              <option value="Inch">Inch</option>
              <option value="foot">foot</option>
              <option value="yard">yard</option>
              <option value="barrel">barrel</option>
              <option value="bag">bag</option>
              <option value="carton">carton</option>
              <option value="event">event</option>
              <option value="person">person</option>
              <option value="use">use</option>
              <option value="visit">visit</option>
            </Input>
          </div>
          <div className="deal-factor-item-input-col pak-description">
            <Input
              type="text"
              className="deal-factor-item-input"
              value={newItems[item.Id]?.description || ""}
              onChange={(e) =>
                handleInputChange(item.Id, "description", e.target.value)
              }
              placeholder="Item Description"
            />
          </div>
          <div className="deal-factor-item-input-col add-button-plus">
            <span
              className="deal-factor-item-add-button"
              onClick={() => handleAddItemToPackages(item.Id)}
            >
              <IoMdAddCircle size={30} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DealFactorItems;
